import { addBasePath } from './addBasePath';

export const getShippingIconByTitle = (name: string): string => {
  if (!name) return '';
  const normalizedString = name.toLowerCase();

  if (normalizedString.includes('fedex')) return addBasePath('/footer/fedex.svg');
  if (normalizedString.includes('dpd')) return addBasePath('/footer/dpd.svg');
  if (normalizedString.includes('inpost')) return addBasePath('/footer/inpost.svg');
  if (normalizedString.includes('poczta polska') || normalizedString.includes('p.p.')) return addBasePath('/footer/pocztapolska.svg');
  if (normalizedString.includes('raben')) return addBasePath('/footer/raben.svg');
  if (normalizedString.includes('ups')) return addBasePath('/footer/ups.svg');

  return '';
};

const PAYMENT_METHODS_ICONS = {
  payu_gateway: ['/footer/payu.svg'],
  'payu_gateway--blik': ['/footer/blik.svg'],
  'payu_gateway--ap': ['/footer/gpay.svg'],
  'payu_gateway--jp': ['/footer/applepay.svg'],
  'payu_gateway--c': ['/footer/visa.svg', '/footer/mastercard.svg'],
  'payu_gateway--dpp': ['/footer/paypro.svg'],
  payu_gateway_blik: ['/footer/blik.svg'],
  payu_gateway_applepay: ['/footer/applepay.svg'],
  payu_gateway_card: ['/footer/visa.svg', '/footer/mastercard.svg'],
  cashondelivery: ['/footer/wallet.svg'],
  banktransfer: ['/footer/bank.svg'],
};
export const getPaymentIconsByCode = (code: string): string[] => (PAYMENT_METHODS_ICONS[code]
  ? PAYMENT_METHODS_ICONS[code].map((s: string) => addBasePath(s))
  : []);
